var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    viewBox: "0 0 81 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7539 4.0196L80.4267 47.9179C80.8339 49.9787 79.4917 51.9815 77.4311 52.3887L13.7162 64.9765C11.6555 65.3837 9.65264 64.0415 9.24545 61.9809L0.572798 18.0826C0.165611 16.0218 1.5078 14.019 3.56842 13.6118L67.2831 1.02398C69.3439 0.616788 71.3467 1.95882 71.7539 4.0196Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4308 52.3898L13.7166 64.9765C11.656 65.3847 9.65352 64.0423 9.24523 61.9817L8.67383 59.0886C9.29961 59.2844 9.98352 59.3315 10.6729 59.1956L71.7533 4.01953L80.4276 47.9184C80.8338 49.979 79.4915 51.9815 77.4308 52.3898Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4737 61.4496H8.87871C6.77699 61.4496 5.07324 59.7457 5.07324 57.6441V12.8973C5.07324 10.7955 6.77715 9.0918 8.87871 9.0918H73.8249C75.9267 9.0918 77.6304 10.7957 77.6304 12.8973V43.2895C77.6304 43.8718 77.4012 44.4309 76.9926 44.8455L62.1481 59.9116C61.1785 60.8955 59.8549 61.4496 58.4737 61.4496Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1126 16.2993V49.799C69.5785 52.3712 66.5782 55.4148 64.5557 57.4684H13.8183C12.0369 57.4684 10.5913 56.0227 10.5913 54.2413V16.2993C10.5913 14.5179 12.0369 13.0723 13.8183 13.0723H68.8856C70.667 13.0723 72.1126 14.5179 72.1126 16.2993Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6304 54.5996V57.644C77.6304 59.7446 75.9256 61.4495 73.8249 61.4495H8.87871C6.77809 61.4495 5.07324 59.7446 5.07324 57.644V54.5996H77.6304Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6102 54.5843C10.6202 54.6788 10.6349 54.7718 10.6529 54.8636C10.6562 54.8807 10.6596 54.8977 10.6632 54.9146C10.6824 55.0049 10.7052 55.0939 10.7318 55.1814C10.7365 55.1968 10.7416 55.2119 10.7466 55.2272C10.7752 55.3164 10.8068 55.4043 10.8427 55.4899C10.846 55.4977 10.8497 55.505 10.853 55.5128C10.8883 55.5949 10.9272 55.6749 10.9688 55.7532C10.9749 55.7649 10.9808 55.7768 10.9871 55.7885C11.0297 55.8663 11.0763 55.9416 11.1249 56.0153C11.1358 56.0321 11.1468 56.0486 11.158 56.065C11.2065 56.1355 11.2577 56.2041 11.3115 56.2702C11.3249 56.2868 11.3388 56.303 11.3524 56.3194C11.4077 56.3849 11.4651 56.4488 11.5252 56.5096C11.5379 56.5222 11.551 56.5344 11.5638 56.5469C11.6207 56.6025 11.6794 56.6561 11.7404 56.7074C11.7521 56.7172 11.763 56.7275 11.7749 56.7372C12.3315 57.1932 13.0426 57.4672 13.8177 57.4672H64.5551C66.1379 55.8602 68.3193 53.6471 70.4077 51.5275L53.2643 35.8007C51.9393 34.5852 49.9048 34.5852 48.5798 35.8007L40.9729 42.7788L29.013 30.8258C27.5958 29.1289 24.9444 29.1735 23.5933 30.9614L10.5913 48.1672V54.2402C10.5913 54.3425 10.5972 54.4433 10.6066 54.5433C10.6079 54.5569 10.6087 54.5707 10.6102 54.5843Z",
    fill: "url(#paint5_linear_0_1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2643 35.8022C51.9393 34.5868 49.9047 34.5868 48.5797 35.8022L39.2476 44.363L49.1352 57.4469L64.5646 57.4596C66.1463 55.8543 68.323 53.6449 70.4091 51.5299L53.2643 35.8022Z",
    fill: "url(#paint6_linear_0_1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3602 38.6423C55.7725 39.1193 54.8474 39.0087 54.4138 38.3084L54.4119 38.3065C53.8986 37.4739 52.6888 37.4739 52.1753 38.3065V38.3084C51.662 39.1411 50.4503 39.1411 49.9371 38.3084V38.3065C49.6813 37.8894 49.2495 37.6825 48.8178 37.6825C48.3861 37.6825 47.9544 37.8894 47.6986 38.3065C47.2325 39.0629 46.1913 39.1318 45.6216 38.5151L48.58 35.8016C49.9042 34.5844 51.9394 34.5844 53.2635 35.8016L56.3602 38.6423Z",
    fill: "url(#paint7_linear_0_1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9837 35.4777C25.9619 35.4777 25.9405 35.4788 25.9187 35.4795C25.943 35.2815 25.9556 35.0799 25.9556 34.8754C25.9556 32.1493 23.7456 29.9395 21.0197 29.9395C18.9894 29.9395 17.2455 31.1654 16.4875 32.9174C16.3109 32.8466 16.1183 32.8073 15.9166 32.8073C15.0692 32.8073 14.3823 33.4941 14.3823 34.3415C14.3823 34.5996 14.4464 34.8429 14.5592 35.0563C13.4728 35.4624 12.6992 36.5096 12.6992 37.7377C12.6992 39.3184 13.9808 40.5999 15.5614 40.5999H25.9839C27.3983 40.5999 28.5448 39.4534 28.5448 38.039C28.5448 36.6246 27.3981 35.4777 25.9837 35.4777Z",
    fill: "#008BF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1518 57.4674L13.2994 57.4257C11.7649 57.1773 10.5913 55.8457 10.5913 54.2404V48.1674L23.5935 30.9618C24.9799 29.1273 27.736 29.1273 29.1224 30.962L39.2479 44.3618L49.1355 57.4457L49.1518 57.4674Z",
    fill: "url(#paint8_linear_0_1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7836 34.4852C31.2104 35.091 30.1782 35.0167 29.7139 34.2657V34.2621C29.4562 33.8467 29.0264 33.6399 28.5946 33.6399C28.1629 33.6399 27.7329 33.8467 27.4754 34.2639C27.2179 34.6792 26.7879 34.888 26.3562 34.888C25.9245 34.888 25.4945 34.6794 25.237 34.2639C24.9795 33.8486 24.5495 33.6399 24.1178 33.6399C23.6861 33.6399 23.2561 33.8485 22.9986 34.2639C22.5361 35.0149 21.5076 35.0892 20.9326 34.4853L23.5936 30.9627C24.9793 29.127 27.7365 29.127 29.1225 30.9627L31.7836 34.4852Z",
    fill: "url(#paint9_linear_0_1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4357 44.1973C77.4357 44.1973 77.3232 44.5157 76.8805 44.9584C76.7162 45.1227 62.2354 59.8223 62.2354 59.8223C61.2102 60.8627 59.8104 61.4488 58.3496 61.4488C59.6105 61.4488 60.6329 60.4266 60.6329 59.1655V48.0027C60.6329 45.901 62.3368 44.1973 64.4384 44.1973H77.4357Z",
    fill: "url(#paint10_linear_0_1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1927 25.2883C53.1709 25.2883 53.1495 25.2894 53.1277 25.29C53.1519 25.092 53.1646 24.8905 53.1646 24.6859C53.1646 21.9598 50.9546 19.75 48.2287 19.75C46.1984 19.75 44.4545 20.9759 43.6965 22.728C43.5199 22.6572 43.3273 22.6178 43.1255 22.6178C42.2782 22.6178 41.5913 23.3047 41.5913 24.152C41.5913 24.4102 41.6554 24.6534 41.7682 24.8669C40.6818 25.273 39.9082 26.3202 39.9082 27.5483C39.9082 29.1289 41.1898 30.4105 42.7704 30.4105H53.1929C54.6073 30.4105 55.7538 29.2639 55.7538 27.8495C55.7538 26.4352 54.6073 25.2883 53.1927 25.2883Z",
    fill: "#008BF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5985 32.8327C62.8805 32.8327 66.3518 29.3615 66.3518 25.0795C66.3518 20.7974 62.8805 17.3262 58.5985 17.3262C54.3165 17.3262 50.8452 20.7974 50.8452 25.0795C50.8452 29.3615 54.3165 32.8327 58.5985 32.8327Z",
    fill: "url(#paint11_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 40.4846,
    y1: 33.8072,
    x2: 42.2096,
    y2: -51.1422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 44.4121,
    y1: 51.5782,
    x2: 46.5889,
    y2: 61.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363F3E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 41.3531,
    y1: 7.44161,
    x2: 41.3531,
    y2: 62.9283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 41.3532,
    y1: 25.4285,
    x2: 41.3532,
    y2: 65.8265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 41.3531,
    y1: 57.1247,
    x2: 41.3531,
    y2: 62.1398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 39.7142,
    y1: 52.7639,
    x2: 17.5669,
    y2: 30.6182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 60.3951,
    y1: 55.1087,
    x2: 38.351,
    y2: 33.0646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1ACEB8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04959C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 50.6328,
    y1: 38.2185,
    x2: 46.4443,
    y2: 34.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 29.8725,
    y1: 24.0995,
    x2: 29.8725,
    y2: 59.1823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_1",
    x1: 26.359,
    y1: 29.6599,
    x2: 26.359,
    y2: 33.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_1",
    x1: 61.067,
    y1: 45.993,
    x2: 68.5665,
    y2: 53.4941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_1",
    x1: 58.6003,
    y1: 11.6406,
    x2: 58.6003,
    y2: 39.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#FFC954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBackground);
export default __webpack_public_path__ + "static/media/uploadBackground.24a3d780c27db757bbd24457d9f43736.svg";
export { ForwardRef as ReactComponent };